import { NavLink, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { manifest, defaultUrlFor, isTabbed } from '../config/manifest';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export default function DocSidebar({ isOpen, onClose }: Props) {
  const { group: activeGroup, slug: activeSlug } = useParams<{ group: string; slug: string }>();

  // Close mobile drawer on route change.
  useEffect(() => {
    if (isOpen) onClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeGroup, activeSlug]);

  return (
    <>
      {isOpen && (
        <button
          className="doc-sidebar__scrim"
          aria-label="Close navigation"
          onClick={onClose}
        />
      )}
      <nav
        className={`doc-sidebar ${isOpen ? 'doc-sidebar--open' : ''}`}
        aria-label="Documentation sections"
      >
        {manifest.groups.map((group) => (
          <section key={group.id} className="sidebar__group">
            <h3 className="sidebar__group-title">{group.title}</h3>
            <ul className="sidebar__list">
              {group.docs.map((doc) => {
                const isActive = activeGroup === group.id && activeSlug === doc.slug;
                const tabsBadge = isTabbed(doc) ? doc.tabs.length : null;
                return (
                  <li key={doc.slug}>
                    <NavLink
                      to={defaultUrlFor(group.id, doc.slug)}
                      className={`sidebar__link${isActive ? ' sidebar__link--active' : ''}`}
                    >
                      <span className="sidebar__link-title">{doc.title}</span>
                      {tabsBadge && (
                        <span className="sidebar__link-badge">{tabsBadge}</span>
                      )}
                    </NavLink>
                  </li>
                );
              })}
            </ul>
          </section>
        ))}
      </nav>
    </>
  );
}
